import { parse } from 'qs';
import { pipe } from 'fp-ts/lib/pipeable';

export const getQueryString = () =>
  location.search != null && location.search.length > 1
    ? location.search.substr(1)
    : '';

export const getQueryParamsMap = () => pipe(getQueryString(), parse);
